const claimsFromAuthToken = (authToken: string): Record<string, unknown> => {
  try {
    const payload = authToken.split(".")[1] ?? "";
    const claims = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));

    return typeof claims === "object" && claims !== null ? claims : {};
  } catch {
    return {};
  }
};

const fetchConfiguration = async (): Promise<Record<string, unknown>> => {
  try {
    const response = await fetch(`/config.json?${Date.now()}`);
    const configuration = await response.json();

    return typeof configuration === "object" && configuration !== null ? configuration : {};
  } catch {
    return {};
  }
};

export { claimsFromAuthToken, fetchConfiguration };
